import { render, staticRenderFns } from "./LeaderboardView.vue?vue&type=template&id=33f32406&scoped=true&"
import script from "./LeaderboardView.vue?vue&type=script&lang=js&"
export * from "./LeaderboardView.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardView.vue?vue&type=style&index=0&id=33f32406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f32406",
  null
  
)

export default component.exports